import { render, staticRenderFns } from "./ThreeWayCheckbox.vue?vue&type=template&id=1c56f72c&scoped=true&"
import script from "./ThreeWayCheckbox.vue?vue&type=script&lang=js&"
export * from "./ThreeWayCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ThreeWayCheckbox.vue?vue&type=style&index=0&id=1c56f72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56f72c",
  null
  
)

export default component.exports